export const MAX_ERRORS = 6;
export const RETRY_BASE_SEC = 3;
